
<template>
    <div>
        <Button @click="additem">{{$t('global.common.operation_add',{defaultValue:'添加'})}}</Button>
        <Table 
        class="margin-top-20"
        :loading="loading"
        :columns="columns" 
        :data="formList"
        size="small" 
        ref="table"  
        border 
        ></Table>
        <div class="color-error text-center">{{$t('erp.b2c.manualback_note',{defaultValue:'注意：如果ERP SKU、发货数量不填，默认整个订单只有一个包裹。'})}}</div>
        <footer class="text-right margin-top-10">
             <Button type="primary" @click="submit">{{$t('erp.b2c.return',{defaultValue:'回传'})}}</Button>
             <Button class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
        </footer>
        <Spin size="large" fix v-if="formloading"></Spin>
    </div>
</template>
<script>
import { 
    HttpqueryB2COrder,
    HttpVsSkuList,
    HtttrackingReturn,
    HttpGetOrgWarehouseCode
} from '@/service/boss/b2corder'
export default {
    props:['activeids','nodeid'],
    data(){
        return {
            formloading:false,
            loading:false,
            id: this.$route.query.id,
            // issuper: this.$route.query.issuper == 1,
            // nodeid:this.$route.query.nodeid,
            datalist:[],
            volumeTypes:[],
            nowdate:"",
            judge:false,
        }
    },
    computed:{
        formList(){
            return this.datalist || []
        },

        columns() {
            const _this = this
            return [
            {
                // title: 'Tracking NO',
                key: 'trackingNo',
                renderHeader:(h,params)=>{
                    return h('div',[
                        h('Icon',{
                            props:{
                                type:"ios-medical",
                                color:"#ed3f14"
                            },
                        }),
                        h('strong','Tracking NO')
                    ])
                },
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('Input',{
                            props: {
                                size:'small',
                                value:row.trackingNo
                            },
                            on: {
                                'input':(event) => {
                                    row.trackingNo = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>
                        {row.trackingNo}
                        </div>
                    }
                }
            }, {
                // title: '',
                key: 'carrier',
                renderHeader:(h,params)=>{
                    return h('div',[
                        h('Icon',{
                            props:{
                                type:"ios-medical",
                                color:"#ed3f14"
                            },
                        }),
                        h('strong','Carrier')
                    ])
                },
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('vSelect',{
                            props:{  
                                value: _this.datalist[index].carrier,
                                // dropStyle,
                                filterable:true,
                                clearable:true,
                            },  
                            on: {  
                                'on-change':(value) => {  
                                    _this.datalist[index].carrier = value
                                }  
                            },  
                        },
                            _this.volumeTypes.map((json)=>{  
                                // console.log(json)
                                return h('vOption', {  
                                    props: {
                                        value: json.value,
                                        label: json.label
                                    }  
                                });  
                            })
                        )
                    }else{
                        return <div>{row.carrier}</div>
                    }
                }
            }, {
                title: 'ERP SKU',
                key: 'erpSku',
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('Input',{
                            props: {
                                size:'small',
                                value:row.erpSku
                            },
                            on: {
                                'input': (event) => {
                                    row.erpSku = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.erpSku}</div>
                    }
                }
            }, {
                title: this.$t('erp.b2c.quantity_shipped',{defaultValue:'发货数量'}),
                key: 'shipedQuantity',
                width:120,
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('InputNumber',{
                            props: {
                                size:'small',
                                min:1,
                                value:row.shipedQuantity
                            },
                            on: {
                                'input': (event) => {
                                    row.shipedQuantity = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.shipedQuantity}</div>
                    }
                }
            },{
                title: 'Shipping Cost',
                key: 'cost',
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('Input',{
                            props: {
                                size:'small',
                                value:row.cost
                            },
                            on: {
                                'input': (event) => {
                                    row.cost = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.cost}</div>
                    }
                }
            },{
                // title: '',
                key: 'shipmentDate',
                width:220,
                renderHeader:(h,params)=>{
                    return h('div',[
                        h('Icon',{
                            props:{
                                type:"ios-medical",
                                color:"#ed3f14"
                            },
                        }),
                        h('strong',this.$t('erp.b2c.search_outtime',{defaultValue:'发货时间'}))
                    ])
                },
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('DatePicker',{
                            props: {
                                type:'datetime',
                                placeholder:"Select date",
                                value:_this.datalist[index].shipmentDate
                            },
                            on: {
                                'on-change':function(date){
                                    // console.log(date)
                                    _this.datalist[index].shipmentDate = date
                                },
                            },
                        })
                    }else{
                        return <div>{row.shipmentDate}</div>
                    }
                }
            },{
                title: this.$t('global.common.operation',{defaultValue:'操作'}),
                width:140,
                render(h, { row, index }) {
                    return h('div',[
                        h('Button', {
                            props:{
                                type:"primary",
                                size:'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    _this.changeEdit(row)
                                }
                            }
                        },_this.$t('global.common.operation_edit',{defaultValue:'编辑'})),
                        h('Button', {
                            props:{
                                type:"error",
                                size:'small'
                            },
                            on: {
                                click: () => {
                                    _this.comremove(index)
                                }
                            }
                        },_this.$t('global.common.delete',{defaultValue:'删除'}))
                    ])
                }
            },]
        },
    },
    created(){
        this.getNowFormatDate()
        this.getpackages()
    },
    methods:{
        getNowFormatDate(){
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
            this.nowdate =  currentdate;
            // console.log(this.nowdate)
        },
        getpackages(){
            let _this = this
            this.loading = true
            HttpqueryB2COrder({
                orderId: this.activeids,
                node:this.nodeid,
                // contextId: 1
            }).then(res => {
                // console.log(res.data)
                let resdata = res.data.packages
                if(resdata==null){
                    resdata = []
                }else{
                    resdata.map(item=>{
                        item.$Edit = false
                    })
                }
                if(!res.data.logistics.orgWarehouseCode){
                    this.$Message.error(this.$t('erp.b2c.nowarehouse_nocarrier',{defaultValue:'未分配仓库，发货方式不存在'}));
                }else{
                    _this.formloading = true;
                    console.log(res.data.contextId,'contextIdcontextId')
                    HttpGetOrgWarehouseCode({
                        warehouseCode:res.data.logistics.orgWarehouseCode,
                        orgId: res.data.contextId,
                    }).then(res=>{
                        let aaa = [
                            { label: 'WLC', value: 'WLC' },
                            { label: 'YRC', value: 'YRC' },
                            { label: 'Australia Post', value: 'Australia Post' },
                            { label: 'Other', value: 'Other' }
                        ]
                        _this.volumeTypes = res.data.map(item => {
                            return {
                                label: `${item.code}(${item.carrierServiceName})`,
                                value: item.code,
                                attach: {
                                ...item
                                }
                            }
                        })
                        _this.volumeTypes = _this.volumeTypes.concat(aaa)
                        _this.volumeTypes = this.arrayUnique(_this.volumeTypes,'value')
                        _this.volumeTypes.sort(function(a,b){
                            return a.value.localeCompare(b.value)
                        })
                    },err=>{
                        this.errorMessage(err.message);
                    }).finally(result => {
                        _this.formloading = false;
                    })
                }
                // console.log(resdata)


                let filterarr = resdata.filter(item=> {return item.packageFlag == 1}) || []
                if(filterarr.length<1){
                    this.datalist = resdata || []
                }else{
                    this.datalist = filterarr || []
                }

                this.loading = false;
            }, err => {
                this.loading = false;
                this.errorMessage(err.message);
            });
            
        },
        additem(){
            let _this = this
            let itemdata = {
                trackingNo:null,
                carrier:null,
                erpSku:null,
                cost:null,
                shipedQuantity:null,
                shipmentDate:_this.nowdate+' 18:00:00',
                $Edit:true,
            }
            this.datalist.push(itemdata)
            // console.log(this.datalist)
        },
        changeEdit(row){
            this.$set(row, '$Edit', true)
        },
        cancel(){
            this.$emit('on-close')
        },
        submit(){
            
            if(this.datalist.length<1){
                this.$Message.error(this.$t('erp.b2c.leastone_returndata',{defaultValue:'请填写至少一条回传数据'}));
                return
            }
            this.loading = true
            HtttrackingReturn({
                orderId:this.activeids,
                packages:this.datalist
            }).then(res => {
                this.loading = false
                this.$Message.success(res.message);
                this.$emit('on-update');
                this.cancel()
            },err => {
                this.loading = false
                this.errorMessage(err.message);
            })
            
            
        },
        comremove(index) {
            this.datalist.splice(index, 1);
        }
    }
}
</script>
